import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Export = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8536 4.35355C10.6583 4.54882 10.3417 4.54882 10.1464 4.35355L8.5 2.70711L8.5 10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5L7.5 2.70711L5.85355 4.35355C5.65829 4.54882 5.34171 4.54882 5.14645 4.35355C4.95118 4.15829 4.95118 3.84171 5.14645 3.64645L7.64645 1.14645C7.84171 0.951185 8.15829 0.951185 8.35355 1.14645L10.8536 3.64645C11.0488 3.84171 11.0488 4.15829 10.8536 4.35355ZM3.5 5.5C2.39543 5.5 1.5 6.39543 1.5 7.5V12.5C1.5 13.6046 2.39543 14.5 3.5 14.5H12.5C13.6046 14.5 14.5 13.6046 14.5 12.5V7.5C14.5 6.39543 13.6046 5.5 12.5 5.5H11.4286C11.1524 5.5 10.9286 5.72386 10.9286 6C10.9286 6.27614 11.1524 6.5 11.4286 6.5H12.5C13.0523 6.5 13.5 6.94772 13.5 7.5V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5V7.5C2.5 6.94772 2.94772 6.5 3.5 6.5H4.57143C4.84757 6.5 5.07143 6.27614 5.07143 6C5.07143 5.72386 4.84757 5.5 4.57143 5.5H3.5Z"
      />
    </svg>
  )
})

export default Export
